import * as RadixDialog from '@radix-ui/react-dialog';
import React, { forwardRef, ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

type DialogDescriptionProps = Omit<
  RadixDialog.DialogDescriptionProps,
  'asChild' | 'children' | 'id'
> & {
  children: ReactNode;
};

const DialogDescription = forwardRef<
  HTMLParagraphElement,
  DialogDescriptionProps
>(({ children, className, ...props }, ref) => (
  <RadixDialog.Description
    className={cn('text-sm text-muted-foreground', className)}
    ref={ref}
    {...props}
  >
    {children}
  </RadixDialog.Description>
));
DialogDescription.displayName = 'DialogDescription';

export { DialogDescription, type DialogDescriptionProps };
